<template>
	<div v-if="friendlyObj">
		<table class="striped table w-100 bg-white border fixed-layout">
			<thead class="mb-0" style="border-bottom: 2px solid #e4e4e4;">
				<tr class="mb-3">
					<th class="text-bold w-50 p-2">{{ $t("Property") }}</th>
					<th class="text-bold text-center p-2">{{ $t("Value") }}</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(value, prop) in friendlyObj">
					<td>{{ $t(prop).titolize() }}</td> 
					<td v-if="typeof value == 'string' && value.contains('<')" class="text-bold pb-2">
						<pre>{{ $t(value) }}</pre>
					</td>
					<td v-else-if="typeof value == 'string'" class="text-bold pb-2">
						<pre>{{ $t(value) }}</pre>
					</td>

					<td v-else>
						{{ value }}
					</td>
				</tr>
			</tbody>
		</table>

		<!--<div v-for="(value, prop) in friendlyObj" class="row">
			<label>{{ $t(prop).titolize() }} :&nbsp;</label> 
			<span v-if="typeof value == 'string'" class="text-bold pb-2"><pre>{{ $t(value) }}</pre></span>
			<span v-else class="text-bold pl-2 pb-2">{{ value }}</span>
		</div>-->
	</div>
</template>
<script>
import { getFriendlyObject } from "../../../utils/PropertiesLabels";
export default {
	name: "ObjectView",
	props: {
		obj: {
			type: Object,
			//required: true
		},
		withCopyButton: {
			type: Boolean,
			default: false
		},

	},
	data() {
	return {
		friendlyObj: null,
	}
	},
	created() {
		this.friendlyObj=getFriendlyObject(this.obj)[1];
	},
	methods: {

	}
}
</script>